import React from 'react';
import { CtaButton } from './CtaButton';
import { Check, ShieldCheck, Download, Smartphone } from 'lucide-react';
export function OfferSection() {
  return <section className="py-24 px-4 bg-brand-purple" data-id="element-130">
      <div className="max-w-4xl mx-auto text-center" data-id="element-131">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-132">
          Todo lo que recibís hoy
        </h2>
        <p className="text-brand-yellowLight text-xl md:text-2xl font-medium mb-12" data-id="element-133">
          Un sistema completo para no volver a improvisar
        </p>

        <div className="bg-brand-purpleDark rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto text-left border border-white/10" data-id="element-134">
          <h3 className="text-white font-bold text-xl mb-6" data-id="element-135">Lo que incluye:</h3>

          <div className="space-y-4 mb-10" data-id="element-136">
            {['Ebook principal — 7 módulos y 30+ recetas', 'Bonus 1: Lista de compras inteligente', 'Bonus 2: Postres en air fryer', 'Bonus 3: Comida chatarra saludable'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-137">
                <Check className="w-6 h-6 text-brand-yellow flex-shrink-0" strokeWidth={3} data-id="element-138" />
                <span className="text-white font-medium text-lg" data-id="element-139">{item}</span>
              </div>)}
          </div>

          <div className="text-center mb-8" data-id="element-140">
            <p className="text-gray-400 line-through text-xl mb-1" data-id="element-141">
              $30.000 valor real
            </p>
            <p className="text-brand-yellow text-6xl md:text-7xl font-bold tracking-tight" data-id="element-142">
              $6.999 <span className="text-2xl md:text-3xl" data-id="element-143">ARS</span>
            </p>
          </div>

          <CtaButton text="→ Quiero acceder ahora" size="xl" className="w-full mb-6" data-id="element-144" />

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-gray-300 font-medium" data-id="element-145">
            <div className="flex items-center gap-1" data-id="element-146">
              <ShieldCheck className="w-4 h-4" data-id="element-147" /> Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-148">
              <Download className="w-4 h-4" data-id="element-149" /> Descarga instantánea
            </div>
            <div className="flex items-center gap-1" data-id="element-150">
              <Smartphone className="w-4 h-4" data-id="element-151" /> Funciona en cualquier
              dispositivo
            </div>
          </div>
        </div>
      </div>
    </section>;
}